import React, {useEffect, useState} from 'react';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';

import http from 'services/http';
import {alerta} from 'components/Alert';
import formatMoney from 'utils/formatMoney';
import PermissionGate from 'utils/PermissionGate';
import {useGetUserPermission} from 'hook/permissions';
import Pagination from 'components/Paginacao';
import 'components/Paginacao/style.css';
import {BadgeSituacao, trataErroEsportivas, AvisoModuloBloqueado} from '../shared';

const situacoes = [
    {label: 'Todas', value: ''},
    {label: 'Pendente', value: 'pendente'},
    {label: 'Vencedor', value: 'vencedor'},
    {label: 'Perdedor', value: 'perdedor'},
    {label: 'Pago', value: 'pago'},
    {label: 'Cancelado', value: 'cancelado'},
];

export default function Apostas() {
    const [apostas, setApostas] = useState([]);
    const [meta, setMeta] = useState(null);
    const [pagina, setPagina] = useState(1);

    const [codigo, setCodigo] = useState('');
    const [situacao, setSituacao] = useState('');
    const [operadorId, setOperadorId] = useState('');
    const [gerenteId, setGerenteId] = useState('');
    const [dataInicial, setDataInicial] = useState(dayjs().format('YYYY-MM-DD'));
    const [dataFinal, setDataFinal] = useState(dayjs().format('YYYY-MM-DD'));

    const [listaOperadores, setListaOperadores] = useState([]);
    const [listaGerentes, setListaGerentes] = useState([]);

    const [aposta, setAposta] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [carregaAcao, setCarregaAcao] = useState(false);
    const [moduloBloqueado, setModuloBloqueado] = useState(false);

    const nivel = localStorage.getItem('nivel');
    const permissoes = useGetUserPermission();
    const podeVerDetalhe = permissoes && permissoes.includes('Ver aposta esportivas');

    useEffect(() => {
        requestApostas(1);

        if (nivel === 'admin') {
            requestUsuarios('gerente', setListaGerentes);
            requestUsuarios('operador', setListaOperadores);
        }
    }, []);

    const requestUsuarios = async (nivelUsuario, setLista, gerenteId) => {
        try {
            const response = await http.get('/usuarios', {
                params: {nivel: nivelUsuario, resumida: true, gerente_id: gerenteId},
            });

            setLista(response.data.data);
        } catch (e) {
        }
    };

    const requestApostas = async (novaPagina = 1) => {
        setIsLoading(true);
        setPagina(novaPagina);

        try {
            const response = await http.get('/esportivas/apostas', {
                params: {
                    page: novaPagina,
                    codigo: codigo || undefined,
                    situacao: situacao || undefined,
                    operador_id: operadorId || undefined,
                    gerente_id: gerenteId || undefined,
                    data_inicial: dataInicial || undefined,
                    data_final: dataFinal || undefined,
                },
            });

            setApostas(response.data.data.data);
            setMeta(response.data.data.meta);
        } catch (e) {
            trataErroEsportivas(e, setModuloBloqueado);
        }

        setIsLoading(false);
    };

    const mudarGerente = (id) => {
        setGerenteId(id);
        setOperadorId('');
        requestUsuarios('operador', setListaOperadores, id || undefined);
    };

    const abrirDetalhe = async (codigoAposta) => {
        try {
            const response = await http.get(`/esportivas/apostas/${codigoAposta}`);
            setAposta(response.data.data);
        } catch (e) {
            trataErroEsportivas(e, setModuloBloqueado);
        }
    };

    const pagarAposta = (codigoAposta) => {
        Swal.fire({
            title: 'Deseja pagar a aposta?',
            text: 'Essa ação não poderá ser revertida!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
            confirmButtonText: 'Sim, desejo pagar!',
            cancelButtonText: 'Não, voltar',
        }).then(async (result) => {
            if (result.value) {
                try {
                    setCarregaAcao(true);
                    const response = await http.patch(`/esportivas/apostas/${codigoAposta}/pagar`);
                    alerta(response.data);
                    setAposta(null);
                    requestApostas(pagina);
                } catch (e) {
                    trataErroEsportivas(e, setModuloBloqueado);
                }
                setCarregaAcao(false);
            }
        });
    };

    const cancelarAposta = (codigoAposta) => {
        Swal.fire({
            title: 'Deseja cancelar a aposta?',
            text: 'Essa ação não poderá ser revertida!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
            confirmButtonText: 'Sim, desejo cancelar!',
            cancelButtonText: 'Não, voltar',
        }).then(async (result) => {
            if (result.value) {
                try {
                    setCarregaAcao(true);
                    const response = await http.patch(`/esportivas/apostas/${codigoAposta}/cancelar`);
                    alerta(response.data);
                    setAposta(null);
                    requestApostas(pagina);
                } catch (e) {
                    trataErroEsportivas(e, setModuloBloqueado);
                }
                setCarregaAcao(false);
            }
        });
    };

    const botoesAcao = (item) => (
        <>
            {item.situacao === 'vencedor' && (
                <PermissionGate permissions={["Pagar aposta esportivas"]}>
                    <button
                        className="btn btn-success mr-1"
                        disabled={carregaAcao}
                        onClick={() => pagarAposta(item.codigo)}
                    >
                        Pagar
                    </button>
                </PermissionGate>
            )}
            {item.situacao !== 'cancelado' && item.situacao !== 'pago' && (
                <PermissionGate permissions={["Remover aposta esportivas"]}>
                    <button
                        className="btn btn-danger"
                        disabled={carregaAcao}
                        onClick={() => cancelarAposta(item.codigo)}
                    >
                        Cancelar
                    </button>
                </PermissionGate>
            )}
        </>
    );

    const modalDetalhe = () => (aposta && (
        <div className="modal" style={{display: 'block', overflowY: 'scroll', maxHeight: '100%'}}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-body">
                        <div style={{fontWeight: 'bold', marginBottom: 5}}>
                            Aposta {aposta.codigo} <BadgeSituacao situacao={aposta.situacao}/>
                        </div>

                        <table className="table border">
                            <tbody>
                            <tr>
                                <td>Cambista</td>
                                <td>
                                    {aposta.cambista?.login}
                                    {aposta.cambista?.gerente && ` (gerente: ${aposta.cambista.gerente.login})`}
                                </td>
                            </tr>
                            <tr>
                                <td>Data</td>
                                <td>{dayjs(aposta.created_at).format('DD/MM/YYYY HH:mm')}</td>
                            </tr>
                            {aposta.ip && (
                                <tr>
                                    <td>IP</td>
                                    <td>{aposta.ip}</td>
                                </tr>
                            )}
                            <tr>
                                <td>Valor</td>
                                <td>{formatMoney(parseFloat(aposta.valor).toFixed(2))}</td>
                            </tr>
                            <tr>
                                <td>Odd total</td>
                                <td>{parseFloat(aposta.total_odds).toFixed(2).replace('.', ',')}</td>
                            </tr>
                            <tr>
                                <td>Prêmio</td>
                                <td>{formatMoney(parseFloat(aposta.premio).toFixed(2))}</td>
                            </tr>
                            <tr>
                                <td>Comissão</td>
                                <td>{formatMoney(parseFloat(aposta.comissao).toFixed(2))}</td>
                            </tr>
                            {aposta.pago_em && (
                                <tr>
                                    <td>Pago em</td>
                                    <td>{dayjs(aposta.pago_em).format('DD/MM/YYYY HH:mm')}</td>
                                </tr>
                            )}
                            {aposta.cancelado_em && (
                                <tr>
                                    <td>Cancelado em</td>
                                    <td>{dayjs(aposta.cancelado_em).format('DD/MM/YYYY HH:mm')}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>

                        <div style={{fontWeight: 'bold', margin: '10px 0 5px'}}>Palpites</div>

                        <table className="table text-center border">
                            <thead>
                            <tr>
                                <th className="text-left">Evento</th>
                                <th>Mercado</th>
                                <th>Palpite</th>
                                <th>Odd</th>
                                <th>Situação</th>
                            </tr>
                            </thead>
                            <tbody>
                            {aposta.palpites && aposta.palpites.map((palpite) => (
                                <tr key={palpite.id}>
                                    <td className="text-left align-middle">
                                        {palpite.event?.team_home} x {palpite.event?.team_out} <br/>
                                        <small className="text-muted">
                                            {palpite.event?.league}
                                            {palpite.event?.start_at &&
                                                ` — ${dayjs(palpite.event.start_at).format('DD/MM/YYYY HH:mm')}`}
                                        </small>
                                    </td>
                                    <td className="align-middle">{palpite.market?.name}</td>
                                    <td className="align-middle">
                                        {palpite.odd_option}
                                        {palpite.odd_argument && ` ${palpite.odd_argument}`}
                                    </td>
                                    <td className="align-middle">
                                        {parseFloat(palpite.odd_value).toFixed(2).replace('.', ',')}
                                    </td>
                                    <td className="align-middle">
                                        <BadgeSituacao situacao={palpite.situacao}/>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>

                        <div className="text-center">
                            {botoesAcao(aposta)}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            style={{width: '100%'}}
                            type="button"
                            className="btn btn-danger"
                            onClick={() => setAposta(null)}
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    ));

    if (moduloBloqueado) {
        return (
            <>
                <div className="titulo-principal">Apostas Esportivas</div>
                <AvisoModuloBloqueado/>
            </>
        );
    }

    return (
        <>
            <div className="titulo-principal">Apostas Esportivas</div>

            <div className="conteudo-principal">
                <div className="d-flex tres-colunas">
                    {nivel === 'admin' && (
                        <>
                            <div className="form-group">
                                <label>Gerente</label>
                                <select
                                    className="form-control"
                                    value={gerenteId}
                                    onChange={(e) => mudarGerente(e.target.value)}
                                >
                                    <option value="">Gerentes</option>
                                    {listaGerentes.map((usuario) => (
                                        <option key={usuario.id} value={usuario.id}>
                                            {usuario.login.toUpperCase()}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Cambista</label>
                                <select
                                    className="form-control"
                                    value={operadorId}
                                    onChange={(e) => setOperadorId(e.target.value)}
                                >
                                    <option value="">Cambistas</option>
                                    {listaOperadores.map((usuario) => (
                                        <option key={usuario.id} value={usuario.id}>
                                            {usuario.login.toUpperCase()}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </>
                    )}
                    <div className="form-group">
                        <label>Situação</label>
                        <select
                            className="form-control"
                            value={situacao}
                            onChange={(e) => setSituacao(e.target.value)}
                        >
                            {situacoes.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="d-flex quatro-colunas">
                    <div className="form-group">
                        <label>Data inicial</label>
                        <input
                            type="date"
                            className="form-control"
                            value={dataInicial}
                            onChange={(e) => setDataInicial(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Data final</label>
                        <input
                            type="date"
                            className="form-control"
                            value={dataFinal}
                            onChange={(e) => setDataFinal(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Código</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Código do bilhete"
                            value={codigo}
                            onChange={(e) => setCodigo(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    requestApostas(1);
                                }
                            }}
                        />
                    </div>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        style={{width: '32%', height: '38px', alignSelf: 'flex-end', marginBottom: '16px'}}
                        onClick={() => requestApostas(1)}
                    >
                        Buscar
                    </button>
                </div>
            </div>

            {isLoading && <div className="loader"/>}

            {!isLoading && apostas.length === 0 && (
                <div className="conteudo-principal mt-2" style={{padding: 10}}>
                    Nenhuma aposta encontrada.
                </div>
            )}

            {!isLoading && apostas.length > 0 && (
                <div className="conteudo-principal p-0 mt-2">
                    <table className="table text-center border">
                        <thead>
                        <tr>
                            <th>Código</th>
                            <th>Data</th>
                            <th>Operador</th>
                            <th>Valor</th>
                            <th>Odd</th>
                            <th>Prêmio</th>
                            {podeVerDetalhe && <th>Bilhete</th>}
                            <th>Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        {apostas.map((item) => (
                            <tr key={item.codigo}>
                                <td className="align-middle">
                                    {item.codigo} <br/>
                                    <BadgeSituacao situacao={item.situacao}/>
                                </td>
                                <td className="align-middle">
                                    {dayjs(item.created_at).format('DD/MM')} <br/>
                                    {dayjs(item.created_at).format('HH:mm')}
                                </td>
                                <td className="align-middle">
                                    {item.cambista?.login} <br/>
                                    {item.cambista?.gerente?.login}
                                </td>
                                <td className="align-middle">
                                    {formatMoney(parseFloat(item.valor).toFixed(2))} <br/>
                                    {formatMoney(parseFloat(item.comissao).toFixed(2))}
                                </td>
                                <td className="align-middle">
                                    {parseFloat(item.total_odds).toFixed(2).replace('.', ',')} <br/>
                                    <small className="text-muted">
                                        {item.palpites ? item.palpites.length : 0} palpite(s)
                                    </small>
                                </td>
                                <td className="align-middle">
                                    {formatMoney(parseFloat(item.premio).toFixed(2))} <br/>
                                    {item.pago_em && dayjs(item.pago_em).format('DD/MM')}
                                </td>
                                {podeVerDetalhe && (
                                    <td className="align-middle">
                                        <button
                                            className="btn btn-info"
                                            onClick={() => abrirDetalhe(item.codigo)}
                                        >
                                            Ver
                                        </button>
                                    </td>
                                )}
                                <td className="align-middle">
                                    {botoesAcao(item)}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {meta && (
                        <Pagination
                            currentPage={pagina}
                            totalCount={meta.total}
                            pageSize={meta.per_page}
                            onPageChange={(novaPagina) => requestApostas(novaPagina)}
                        />
                    )}
                </div>
            )}

            {modalDetalhe()}
        </>
    );
}
